import User from './User';

export class Assessor extends User {
  static get entity() {
    return 'assessors';
  }

  static get fk() {
    return 'assessor';
  }

  static fields() {
    return {
      ...User.fields()
    };
  }

  static apiConfig = {
    actions: {
      ...User.apiConfig?.actions
    }
  };
}

export default Assessor;
